import * as React from "react";
import { Component } from "react";
import { connect } from "react-redux";

import Licensee from "../../screens/Licensee";
import {
  /* fetchCountryList, */ fetchCntryCrnvy,
  fetchStates,
  fetchDistrictById,
  clearDistrictById,
  AddLicenseeProfile,
  EditLicensee,
  fetchLicenseeList,
  DeleteLicensee,
  pageSelected,
} from "./action";

class LicenseeContainer extends Component {
  render() {
    return (
      <Licensee
        fetchCntryCrnvy={this.props.fetchCntryCrnvy}
        cntrycrncyList={this.props.cntrycrncyList}
        fetchStates={this.props.fetchStates}
        statesList={this.props.statesList}
        fetchDistrictById={this.props.fetchDistrictById}
        clearDistrictById={this.props.clearDistrictById}
        districtById={this.props.districtById}
        AddLicenseeProfile={this.props.AddLicenseeProfile}
        LicenseeCount={this.props.LicenseeCount}
        LicenseeList={this.props.LicenseeList}
        fetchLicenseeList={this.props.fetchLicenseeList}
        EditLicensee={this.props.EditLicensee}
        DeleteLicensee={this.props.DeleteLicensee}
        pageSelected={this.props.pageSelected}
      />
    );
  }
}

function bindAction(dispatch) {
  return {
    fetchLicenseeList: () => {
      dispatch(fetchLicenseeList());
    },
    fetchCntryCrnvy: () => {
      dispatch(fetchCntryCrnvy());
    },
    fetchStates: () => {
      dispatch(fetchStates());
    },
    fetchDistrictById: (value) => {
      dispatch(fetchDistrictById(value));
    },
    clearDistrictById: () => {
      dispatch(clearDistrictById());
    },
    AddLicenseeProfile: (value) => {
      dispatch(AddLicenseeProfile(value));
    },
    EditLicensee: (value) => {
      dispatch(EditLicensee(value));
    },
    DeleteLicensee: (value) => {
      dispatch(DeleteLicensee(value));
    },
    pageSelected: (value) => {
      dispatch(pageSelected(value));
    },
  };
}

function mapStateToProps(state) {
  return {
    districtById: state.LicenseeReducer.districtById,
    cntrycrncyList: state.LicenseeReducer.cntrycrncyList,
    statesList: state.LicenseeReducer.statesList,
    LicenseeCount: state.LicenseeReducer.LicenseeCount,
    LicenseeList: state.LicenseeReducer.LicenseeList,
  };
}

export default connect(mapStateToProps, bindAction)(LicenseeContainer);
